import { FaChevronRight, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../../styles/visualization/pathBar.css";

const PathBar = ({ folderPath = [] }) => {
  const navigate = useNavigate();
  if (!folderPath.length) return null;

  const handleNavigate = (index) => {
    if (index === 0) {
      navigate("/f/visualizations");
      return;
    }

    const pathIds = folderPath.slice(1, index + 1).map((f) => f.folderId);
    navigate(`/f/visualizations/${pathIds.join("/")}`);
  };

  return (
    <nav className="folder-pathbar">
      <div className="folder-pathbar-scroll">
        {folderPath.map((folder, index) => {
          const isLast = index === folderPath.length - 1;
          const isRoot = index === 0;

          return (
            <div className="folder-pathbar-item" key={folder.folderId}>
              {!isLast ? (
                <button
                  className={`folder-pathbar-link ${isRoot ? "home-link" : ""}`}
                  onClick={() => handleNavigate(index)}
                  title={folder.folderTitle}
                >
                  {isRoot ? (
                    <FaHome className="folder-pathbar-home" />
                  ) : (
                    <span className="crumb-text"> {folder.folderTitle}</span>
                  )}
                </button>
              ) : (
                <span
                  className={`folder-pathbar-current ${
                    isRoot ? "home-current" : ""
                  }`}
                  title={folder.folderTitle}
                >
                  {isRoot ? (
                    <FaHome className="folder-pathbar-home" />
                  ) : (
                    folder.folderTitle
                  )}
                </span>
              )}

              {!isLast && (
                <FaChevronRight className="folder-pathbar-separator" />
              )}
            </div>
          );
        })}
      </div>
    </nav>
  );
};

export default PathBar;
